
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import FileExtractorPdfIcmsUpload from "../components/file.extractorddficms.upload";

export const PdfExtractorIcms: React.FC = () => {
  return (
    <PageLayout>
      <PageTitle
        title="Extrator PDF - Pernambuco"
        description="Envie seus arquivos PDF e receba um ZIP com os Excel consolidados."
      />
      <ContentContainer>
        <FileExtractorPdfIcmsUpload />
      </ContentContainer>
    </PageLayout>
  );
};